import axios from '@/core/http'

class Repository {
  URL = ''
  axios = axios

  async getAll() {
    return axios.get(this.URL)
  }
  async $getAll() {
    const response = await this.getAll()
    return response.data
  }
  async getPage(page: number, params?: object) {
    return axios.get(this.URL, {
      params: {
        ...params,
        page,
      },
    })
  }
  async $getPage(page: number, params?: object) {
    const response = await this.getPage(page, params)
    return response.data
  }
  get(id: string) {
    return axios.get(this.URL + id + '/')
  }
  async $get(id: string) {
    const response = await axios.get(this.URL + id + '/')
    return response.data
  }
  create(payload: object) {
    return axios.post(this.URL, payload)
  }
  update(id: string, payload) {
    return axios.put(this.URL + id + '/', payload)
  }
  delete(id: string) {
    return axios.delete(this.URL + id + '/')
  }
  query(params: object) {
    return axios.get(this.URL, {
      params,
    })
  }
}

export { Repository }
